import {Injectable} from '@angular/core';
import {CacheService, PaginationService, SimpleEntityService} from "@customcoding/shared";
import {HttpClient} from "@angular/common/http";
import moment from "moment/moment";
import {Diagnosis, DiagnosisCreateRequest, DiagnosisUpdateRequest} from "../shared/models/diagnosis";

@Injectable({
  providedIn: 'root'
})
export class DiagnosisService extends SimpleEntityService<Diagnosis, DiagnosisCreateRequest, DiagnosisUpdateRequest> {

	constructor(http: HttpClient, pagination: PaginationService,private cache: CacheService) {
		super(http, pagination, '/api/scap/diagnosis');
	}

	allCached(){
		return this.cache.get<Diagnosis[]>(this.apiEndpoint + '?isPaginated=0',moment.duration('5','minutes'));
	}

	getCached(id: number){
		return this.cache.get<Diagnosis>(`${this.apiEndpoint}/${id}`);
	}
}

